import React from 'react';
import { useFela } from 'react-fela';
import errorImg from './player-error.svg';

const rules = () => ({
  height: '26.3%',
  width: '13.26%',
});

const ErrorImage = () => {
  const { css } = useFela();

  return (
    <img className={css(rules)} src={errorImg} alt="player error" />
  );
};

export default React.memo(ErrorImage);
